import { BaseApiModel } from './BaseApiModel';

export class Session extends BaseApiModel {
  public contractId: string;
  public userId: string;
  public startsAt: string;
  public step: string;
}
